export const longCache = {
    staleTime: 60 * (60 * 1000), 
    cacheTime: 70 * (60 * 1000),
}